import React from "react";
import usendLogo from "../../assets/img/usendlogo.png";
// import handLogo from "../../assets/img/hand.png";

export default function WelcomeTitle({ title, subTitle, shopify }) {
  return (
    <div>
     {!shopify && <img src={usendLogo} alt="logo" />}
   
      <h2  style={{ fontWeight: 600, lineHeight: 1, marginBottom:0 }}>{title}</h2>
      <h3 style={{fontWeight:300, marginTop:"10px"}}>{subTitle}</h3>
    </div>
  );
}
